angular.module('app.controllers.non-paginated-forms.supplier', [])
    .controller("SupplierController", function ($scope, $window, $http, appConstants) {
        $scope.aversion = appConstants.version;
        $scope.form_processed = "";
        $scope.form_name = "Supplier Profile Contractor";
        var resp = [];  // new array
        $scope.caprequired = appConstants.captchaRequired; // localhost = false otherwise true
        $scope.allowedChars = /^[A-z0-9-'.,\!\+\(\)\/ ]+$/;
        $scope.addressChars = /^[A-z0-9-'.,\!\+\(\)\/\# ]+$/;
        $scope.onlyNumbers = /^([0-9]*)$/;
        $scope.validEmail = /^([\w-+\!\#\$\%\&]+(?:\.[\w-+\!\#\$\%\&]+)*)@((?:[A-z0-9-)]+\.)*\w[A-z0-9-]{0,66})\.([A-z0-9-]{2,8}(?:\.[A-z0-9-]{8})?)$/i;
        $scope.validDateMDY = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

        $scope.form_info = [
            "W-9 This application is not the official IRS form W-9. The" +
            " information collected below will be used to electronically complete the" +
            " W-9 form whose format can be viewed by clicking the 'W-9 in PDF' link" +
            " at the bottom of this application. The most current version of this" +
            " form can be found at www.irs.gov. Please note that by opening this link" +
            " you are leaving a secured website. By opening this link, you agree to" +
            " hold harmless Southwest Gas Corporation, its officers, directors," +
            " employees, agents, contractors, and representatives from any claims or" +
            " damages of any kind arising or resulting from the use or access to the" +
            " linked website."
        ];

        $scope.success_response = [
            "Thank you for your interest in doing business with Southwest Gas Corporation. Your company profile information" +
            " will be reviewed and forwarded to the appropriate contact.",
            "Please attach a sample copy of your invoice via the link provided.",
            "If you are a certified diverse supplier, please attach a copy of your certification via the link provided.",
            "Completing this information does not automatically place you on the bidder&#39;s list. Once this information" +
            " is received, it will be reviewed and entered into our database system and retained for three (3) years. In the" +
            " event that your company is selected to bid, you must provide the appropriate insurance coverage and other" +
            " documents as required by Southwest."
        ];

        $scope.newValue = function (value) {
            $scope.availableservices = [{ label: 'No Services Available', value: "52" }];
            var url = '/swgasws/resources/form/supplierproductsservices/' + value.toString();
            $http.get(url).
                success(function (data, status, headers, config) {
                    $scope.availableservices = data;
                }).
                error(function (data, status, headers, config) {
                    $scope.availableservices = {
                        1: "Miscellaneous",
                        3: "Building Construction",
                        4: "Building Maintenance",
                        5: "Consulting/Training",
                        6: "Engineering",
                        7: "Environmental",
                        10: "Pipeline Construction",
                        11: "Pipeline Maintenance",
                        12: "Property Lease/Rental",
                        13: "Technology",
                        14: "Temporary Employment",
                        15: "Automotive Parts, Repairs & Maintenance",
                        52: "Other"
                    };
                });
        };

        $window.setCapRequired = function (value) {
            $scope.caprequired = value;
            $scope.$digest();
            //$log.debug("Captcha Required: " + value);
        };

        $scope.updateTINType = function (value) {
            if (value === "Individual") {
                $scope.ssnneeded = true;
            }
            else {
                $scope.ssnneeded = false;
            }
            $scope.einneeded = !$scope.ssnneeded;
        };

        /* company is same as w9_name */
        $scope.$watch('w9_name', function (value) {
            $scope.company = value;
        });
        $scope.$watch('company', function (value) {
            $scope.w9_name = value;
        });

        /* dba is same as w9_bus */
        $scope.$watch('w9_bus', function (value) {
            $scope.dba = value;
        });
        $scope.$watch('dba', function (value) {
            $scope.w9_bus = value;
        });

        /* own-type-text is same as w9_btype_text */
        $scope.$watch('own_type_text', function (value) {
            $scope.w9_btype_text = value;
        });
        $scope.$watch('w9_btype_text', function (value) {
            $scope.own_type_text = value;
        });

        /* ssn is same as w9_ssn */
        $scope.$watch('w9_ssn', function (value) {
            $scope.ssn = value;
        });
        $scope.$watch('ssn', function (value) {
            $scope.w9_ssn = value;
        });

        /* ein is same as w9_ein */
        $scope.$watch('w9_ein', function (value) {
            $scope.tax_id = value;
        });
        $scope.$watch('ein', function (value) {
            $scope.tax_id = value;
        });


        /* w9_btype and llc_taxclass matches own-type */
        $scope.$watch('w9_btype', function (value) {
            $scope.updateTINType(value);
            if (value === "Individual") {
                $scope.own_type = 'Individual';
            }
            else if (value === "C Corporation") {
                $scope.own_type = 'C Corporation';
            }
            else if (value === "S Corporation") {
                $scope.own_type = 'S Corporation';
            }
            else if (value === "Partnership") {
                $scope.own_type = 'Partnership';
            }
            else if (value === "Trustee Estate") {
                $scope.own_type = 'Trustee Estate';
            }
            else if (value === "Other") {
                $scope.own_type = 'Other';
            }
            else if (value === "LLC" && (!$scope.llc_taxclass || $scope.llc_taxclass === "")) {
                $scope.llc_taxclass = 'C';
            }
        });

        $scope.$watch('llc_taxclass', function (value) {
            if ($scope.w9_btype == "LLC") {
                if (value == "C") {
                    $scope.own_type = 'LLC C Corporation';
                }
                else if (value == "S") {
                    $scope.own_type = 'LLC S Corporation';
                }
                else if (value == "P") {
                    $scope.own_type = 'LLC Partnership';
                }
            }
        });

        /* w9_btype and llc_taxclass matches own-type */
        $scope.$watch('own_type', function (value) {
            $scope.owntypeinconsistent = false;
            $scope.updateTINType(value);

            if (value && value.includes("LLC")) {
                $scope.w9_btype = "LLC";
                if (value == "LLC C Corporation") {
                    $scope.llc_taxclass = 'C';
                }
                else if (value == "LLC S Corporation") {
                    $scope.llc_taxclass = 'S';
                }
                else if (value == "LLC Partnership") {
                    $scope.llc_taxclass = 'P';
                }
            }
            else {
                $scope.w9_btype = value;
                $scope.llc_taxclass = '';
            }

            /*
              if ((value == "Individual") && ($scope.w9_btype != 'Individual')) {
                $scope.owntypeinconsistent = true;
              }
              else if (value && !value.includes("LLC") && (value != "Individual") && (value != $scope.w9_btype)) {
                $scope.owntypeinconsistent = true;
              }
              else if (value && value.includes("LLC")) {
                if ((value == "LLC C Corporation") && ($scope.llc_taxclass != 'C')) {
                  $scope.owntypeinconsistent = true;
                }
                else if ((value == "LLC S Corporation") && ($scope.llc_taxclass != 'S')) {
                  $scope.owntypeinconsistent = true;
                }
                else if ((value == "LLC Partnership") && ($scope.llc_taxclass != 'P')) {
                  $scope.owntypeinconsistent = true;
                }
              }
            */
        });

        $scope.resetForm = function () {
            //alert($scope.resetForm);
            $scope.w9_name = "";
            $scope.form_type = "";
            $scope.w9_bus = "";
            $scope.w9_btype = "";
            $scope.llc_taxclass = "";
            $scope.w9_addr = "";
            $scope.w9_city = "";
            $scope.w9_state = "";
            $scope.w9_zip = "";
            $scope.w9_ssn = "";
            $scope.w9_accnts = "";
            $scope.w9_ein = "";
            $scope.company = "";
            $scope.dba = "";
            $scope.owner = "";
            $scope.address = "";
            $scope.city = "";
            $scope.state = "";
            $scope.zip = "";
            $scope.telephone = "";
            $scope.fax = "";
            $scope.contact = "";
            $scope.con_phone = "";
            $scope.con_email = "";
            $scope.payment_to = "";
            $scope.payment_terms = "";
            $scope.freight_terms = "";
            $scope.fob = "";
            $scope.services = "";
            $scope.specificservice = "";
            $scope.own_type = "";
            $scope.own_type_text = "";
            $scope.tax_id = "";
            $scope.ssn = "";
            $scope.amer_owned = "1";
            $scope.amer_details = "";
            $scope.union_rep = "0";
            $scope.union_details = "";
            $scope.bus_size = "1";
            $scope.emp_num = "";
            $scope.bus_length = "";
            $scope.sales_tax = "0";
            $scope.taxno_ca = "";
            $scope.taxno_az = "";
            $scope.taxno_nv = "";
            $scope.tax_city = "";
            $scope.taxno_city = "";
            $scope.min_black = "";
            $scope.min_hispanic = "";
            $scope.min_native = "";
            $scope.min_asian = "";
            $scope.wom_owned = "";
            $scope.dis_owned = "";
            $scope.lgbt_owned = "";
            $scope.other_owned = "";
            $scope.cert_agency = "";
            $scope.cert_no = "";
            $scope.cert_exp = "";
            $scope.cert_phone = "";
            $scope.cert_city = "";
            $scope.cert_state = "";
            $scope.sig_valid = "1";
            $scope.sig = "";
            $scope.ssnneeded = false;
            $scope.einnneeded = true;
            $('html,body').scrollTop(0);
        };
        $scope.resetForm();

        $scope.submit = function () {
            if ($scope.form_processed === "") {
                $scope.form_processed = "Processing . . .";
                var w9_name = $scope.w9_name,
                    form_type = $scope.form_type,
                    w9_bus = $scope.w9_bus,
                    w9_btype = $scope.w9_btype,
                    llc_taxclass = $scope.llc_taxclass,
                    w9_addr = $scope.w9_addr,
                    w9_city = $scope.w9_city,
                    w9_state = $scope.w9_state,
                    w9_zip = $scope.w9_zip,
                    w9_ssn = $scope.w9_ssn,
                    w9_accnts = $scope.w9_accnts,
                    w9_ein = $scope.w9_ein,
                    company = $scope.company,
                    dba = $scope.dba,
                    owner = $scope.owner,
                    address = $scope.address,
                    city = $scope.city,
                    state = $scope.state,
                    zip = $scope.zip,
                    telephone = $scope.telephone,
                    fax = $scope.fax,
                    contact = $scope.contact,
                    con_phone = $scope.con_phone,
                    con_email = $scope.con_email,
                    payment_to = $scope.payment_to,
                    payment_terms = $scope.payment_terms,
                    freight_terms = $scope.freight_terms,
                    fob = $scope.fob,
                    services = $scope.services,
                    specificservice = $scope.specificservice,
                    own_type = $scope.own_type,
                    own_type_text = $scope.own_type_text,
                    tax_id = $scope.tax_id,
                    ssn = $scope.ssn,
                    amer_owned = $scope.amer_owned,
                    amer_details = $scope.amer_details,
                    union_rep = $scope.union_rep,
                    union_details = $scope.union_details,
                    bus_size = $scope.bus_size,
                    emp_num = $scope.emp_num,
                    bus_length = $scope.bus_length,
                    sales_tax = $scope.sales_tax,
                    taxno_ca = $scope.taxno_ca,
                    taxno_az = $scope.taxno_az,
                    taxno_nv = $scope.taxno_nv,
                    tax_city = $scope.tax_city,
                    taxno_city = $scope.taxno_city,
                    min_black = $scope.min_black,
                    min_hispanic = $scope.min_hispanic,
                    min_native = $scope.min_native,
                    min_asian = $scope.min_asian,
                    wom_owned = $scope.wom_owned,
                    dis_owned = $scope.dis_owned,
                    lgbt_owned = $scope.lgbt_owned,
                    other_owned = $scope.other_owned,
                    cert_agency = $scope.cert_agency,
                    cert_no = $scope.cert_no,
                    cert_exp = $scope.cert_exp,
                    cert_phone = $scope.cert_phone,
                    cert_city = $scope.cert_city,
                    cert_state = $scope.cert_state,
                    sig_valid = $scope.sig_valid,
                    sig = $scope.sig;

                $.ajax({
                    url: "/swgasws/resources/form/supplierprofilecontractor/add",
                    type: "post",
                    dataType: 'json',
                    data: {
                        formId: form_type,
                        w9_name: w9_name,
                        w9_bus: w9_bus,
                        w9_btype: w9_btype,
                        llc_taxclass: llc_taxclass,
                        w9_addr: w9_addr.replace(/#/g, ":"),
                        w9_city: w9_city,
                        w9_state: w9_state,
                        w9_zip: w9_zip,
                        w9_ssn: w9_ssn,
                        w9_accnts: w9_accnts,
                        w9_ein: w9_ein,
                        company: company,
                        dba: dba,
                        owner: owner,
                        address: address.replace(/#/g, ":"),
                        city: city,
                        state: state,
                        zip: zip,
                        telephone: telephone,
                        fax: fax,
                        contact: contact,
                        con_phone: con_phone,
                        con_email: con_email,
                        payment_to: payment_to,
                        payment_terms: payment_terms,
                        freight_terms: freight_terms,
                        fob: fob,
                        services: services,
                        specificservice: specificservice,
                        own_type: own_type,
                        own_type_text: own_type_text,
                        tax_id: tax_id,
                        ssn: ssn,
                        amer_owned: amer_owned,
                        amer_details: amer_details,
                        union_rep: union_rep,
                        union_details: union_details,
                        bus_size: bus_size,
                        emp_num: emp_num,
                        bus_length: bus_length,
                        sales_tax: sales_tax,
                        taxno_ca: taxno_ca,
                        taxno_az: taxno_az,
                        taxno_nv: taxno_nv,
                        tax_city: tax_city,
                        taxno_city: taxno_city,
                        min_black: min_black,
                        min_hispanic: min_hispanic,
                        min_native: min_native,
                        min_asian: min_asian,
                        wom_owned: wom_owned,
                        dis_owned: dis_owned,
                        lgbt_owned: lgbt_owned,
                        other_owned: other_owned,
                        cert_agency: cert_agency,
                        cert_no: cert_no,
                        cert_exp: cert_exp,
                        cert_phone: cert_phone,
                        cert_city: cert_city,
                        cert_state: cert_state,
                        sig_valid: sig_valid,
                        sig: sig,
                        gRecaptchaResponse: grecaptcha.getResponse()
                    },
                    success: function (data) {
                        /* status, sysmessage, message  */
                        resp = data.sysmessage.split("|");
                        switch (data.status) {
                            case 'success':
                                window.location = "/en/supplier-profile-attachment?supplierid=" + resp[0] + "&supplierkey=" + resp[1];
                                $scope.resetForm();
                                $scope.defaultForm.$setPristine();
                                 break;
                            case 'badrequest':
                                document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>" + data.message +
                                    " Please try again later.  The Webmaster has been notified of the following submission problem(s): <br /> " + data.sysmessage + "</span></p>";
                                $scope.resetForm();
                                $scope.defaultForm.$setPristine();
                                break;
                            default:
                                document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>" + data.message + " The Webmaster has been notified of this submission problem.</span></p>";
                                $scope.resetForm();
                                $scope.defaultForm.$setPristine();

                        }  // end switch           

                    },
                    error: function (response) {
                        document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>Your Feedback has NOT been sent due to maintenance.  We apologize for the inconvenience at this time. Please try again later.</span></p>";
                        $scope.resetForm();
                        $scope.defaultForm.$setPristine();
                    }
                });
            }
        };
    });